var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"text_center"},[_c('h2',{staticClass:"header_underline"},[_vm._v("LINE登録完了")]),_c('p',[_vm._v("LINE登録が完了しました。")]),_c('p',[_c('router-link',{staticClass:"decoration_link_arrow_blue",attrs:{"to":{ name: 'Top' }}},[_vm._v("トップページへ戻る")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }